/**
 * EnrollIntentModal — shows when an unauthenticated visitor clicks "Enrol" on
 * a programme card. Lets them choose Sign In or Create Account; the programme
 * id is stored in localStorage so the post-login flow can auto-enrol them.
 */
import { Link } from "react-router-dom";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";
import { Button } from "./ui/button";
import { Info } from "@phosphor-icons/react";
import { setPendingEnrollment } from "../lib/pendingEnrollment";

export default function EnrollIntentModal({ open, onOpenChange, programme }) {
  const remember = () => programme && setPendingEnrollment(programme);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md" data-testid="enroll-intent-modal">
        <DialogHeader>
          <DialogTitle>Enrol in {programme?.code || "this programme"}</DialogTitle>
        </DialogHeader>
        <p className="text-sm text-slate-700">
          You&apos;re about to enrol in <strong>{programme?.title || "this programme"}</strong>. We&apos;ll add it to your dashboard so you can pay and start.
        </p>
        <div className="bg-amber-50 border border-amber-200 px-3 py-2 mt-2 flex gap-2 text-xs text-amber-800">
          <Info size={16} weight="fill" className="shrink-0 mt-0.5" />
          <p>After signing in, please also click <strong>&ldquo;Apply Now&rdquo;</strong> on the programme to complete the official application form.</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mt-4">
          <Link to="/login?next=/my-programmes" onClick={remember} className="block">
            <Button variant="outline" className="w-full rounded-none" data-testid="enroll-intent-signin">Sign In</Button>
          </Link>
          <Link
            to={`/register?mode=programme&programme=${encodeURIComponent(programme?.id || "")}`}
            onClick={remember}
            className="block"
          >
            <Button className="w-full bg-blue-800 hover:bg-blue-900 text-white rounded-none" data-testid="enroll-intent-signup">Create Account</Button>
          </Link>
        </div>
        <p className="text-[11px] text-slate-500 text-center mt-3">
          We&apos;ll remember your selection through sign-in / sign-up.
        </p>
      </DialogContent>
    </Dialog>
  );
}
